import moment from 'moment';
import { DateFormat, TimeFormat, BEDateFormat, BETimeFormat } from '../../Constants';

export function asNumber(value) {
  if (value === '') {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  if (/\.$/.test(value)) {
    // "3." can't really be considered a number even if it parses in js. The
    // user is most likely entering a float.
    return value;
  }
  if (/\.0$/.test(value)) {
    // we need to return this as a string here, to allow for input like 3.07
    return value;
  }
  const n = Number(value);
  const valid = typeof n === 'number' && !Number.isNaN(n);

  if (/\.\d*0$/.test(value)) {
    // It's a number, that's cool - but we need it as a string so it doesn't screw
    // with the user when entering dollar amounts or other values (such as those with
    // specific precision or number of significant digits)
    return value;
  }

  return valid ? n : value;
}

// In the case where we have to implicitly create a schema, it is useful to know what type to use
//  based on the data we are defining
export const guessType = function guessType(value) {
  if (Array.isArray(value)) {
    return 'array';
  }
  if (typeof value === 'string') {
    return 'string';
  }
  if (value == null) {
    return 'null';
  }
  if (typeof value === 'boolean') {
    return 'boolean';
  }
  if (!isNaN(value)) {
    return 'number';
  }
  if (typeof value === 'object') {
    return 'object';
  }
  // Default to string if we can't figure it out
  return 'string';
};

export function pad(num, size) {
  let s = String(num);
  while (s.length < size) {
    s = `0${s}`;
  }
  return s;
}

// /jsonDate deve essere una data o una stringa in formato iso o json
export function switchDateFormat(jsonDate, mode) {
  if (!jsonDate) {
    return '';
  }

  const date = moment.utc(jsonDate);

  if (!date.isValid()) {
    return '';
  }

  switch (mode) {
    case 'datepicker':
    case 'ddMMyyyy': {
      return date.format('DD-MM-YYYY');
    }
    case 'datetime': {
      return date.format(`${DateFormat} ${TimeFormat}`);
    }
    case 'JSdate': // Json Schema form validation
    case 'yyyyMMdd': {
      return date.format('YYYY-MM-DD');
    }
    case 'JSdatetime': {
      return date.format('YYYY-MM-DD[T]HH:mm:ss.SSS'); // `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}.${SSS}`;
    }
    case 'date': {
      return date.format(DateFormat);
    }
    case 'eng':
      return date.format('MM/DD/YYYY');
    default: {
      return date.toJSON();
    }
  }

  // const date = new Date(jsonDate);

  // const yyyy = pad(date.getFullYear(), 4);
  // const MM = pad(date.getMonth() + 1, 2);
  // const dd = pad(date.getDate(), 2);
  // const hh = pad(date.getHours(), 2);
  // const mm = pad(date.getMinutes(), 2);
  // const ss = pad(date.getSeconds(), 2);
  // const SSS = pad(date.getMilliseconds(), 3);

  // switch (mode) {
  //     case "datepicker":
  //     case "ddMMyyyy": {
  //         return `${dd}-${MM}-${yyyy}`;
  //     }
  //     case "JSdate"://Json Schema form validation
  //     case "yyyyMMdd": {
  //         return `${yyyy}-${MM}-${dd}`;
  //     }
  //     case "datetime": {
  //         return `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}.${SSS}`;
  //     }
  //     default: {
  //         return date.toJSON();
  //     }
  // }
}
